<template>
  <div class="form-card">
    <h3 class="form-card-title">
      <span class="title-text">{{$t('labels.acc.maxRegister')}}</span>
      <!--<span class="explain">
        <i class="star">*</i>
        {{ $t('labels.acc.loginPwd.desc') }}
      </span>-->
    </h3>
    <div class="relative-position" v-if="Getter_User_Info.regWalletStatus === 1">
      <div class="form-card-body mb-5">
        <p class="color-333">{{ $t('labels.acc.maxRegister.setupSuccess') }}</p>
      </div>
    </div>
    <div class="form-card-body" v-else>
      <div class="form container-fluid">
        <div :style="{ padding: showMobileView }">
          <div class="row" :style="{ padding: rowPadding }">
            <div class="col-12 col-md-9">
              <div
                class="text-md-left text-center"
                style="font-size:16px;"
              >{{ $t('max.register.desc.bind') }}</div>
              <!-- <div class="text-weight-light" style="font-size:14px;">{{$t('max.register.question')}}<a href="#">{{$t('max.register.helpCenter')}}</a></div> -->
              <div class="d-flex justify-md-start justify-center btns-group mt-2">
                <a
                  v-for="(value, name, index) in btnList"
                  class="mr-md-2 ml-md-0 mr-2 ml-2 mb-1"
                  :href="value.path"
                  target="_blank"
                  :key="index"
                >
                  <img :src="value.icon" alt />
                </a>
              </div>
              <div class="d-flex justify-md-start justify-center btns-group mt-1">
                <a
                  v-for="(value, name, index) in btnList2"
                  class="mr-md-2 ml-md-0 mr-2 ml-2 mb-1"
                  :href="value.path"
                  target="_blank"
                  :key="index"
                >
                  <img :src="value.icon" alt />
                </a>
              </div>
              <!-- <div class="btns-group">
                <a
                  href="https://apps.apple.com/us/app/max-wallet/id1456349663"
                  target="_blank"
                  class="download-btn ios-app-store"
                >
                  APP STORE
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.maxonrow.wallet"
                  target="_blank"
                  class="download-btn google-play"
                >
                  GOOGLE PLAY
                </a>
              </div>-->
            </div>
            <div class="col-12 col-md-3 text-md-right text-center">
              <v-progress-circular v-if="!qrString" indeterminate size="64"></v-progress-circular>
              <QrCode v-else :text="qrString" />
            </div>
          </div>
          <div v-if="pkgType === 'REGISTER'" class="mt-10 mb-20 text-left">
            <v-checkbox v-model="withKyc" :label="$t('max.register.iAgree')"></v-checkbox>
          </div>
          <div class="row bottom-section">
            <div class="col-12 col-sm-4 text-center">
              <img class="img-step" :src="imgStep1" />
              <div class="mb-20">{{ $t('max.register.step1') }}</div>
            </div>
            <div class="col-12 col-sm-4 text-center">
              <img class="img-step" :src="imgStep2" />
              <div class="mb-20">{{ $t('max.register.step2') }}</div>
            </div>
            <div class="col-12 col-sm-4 text-center">
              <img class="img-step" :src="imgStep3" />
              <div class="mb-20">{{ $t('max.register.step3') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import index from './max-register-bind.js';
export default index;
</script>

<style src="@/common/styles/mixin/account-bind.scoped.styl" lang="stylus" scoped></style>
<style lang="stylus" scoped>
@import 'max-register-bind.scoped.styl';
</style>
